import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import IdPwForm from './IdPwForm';
import LearnerInfoForm from './LearnerInfoForm';
import { Header } from "../common";
import { URL } from '../../../../constant';
import { useInput, useInputs } from "../../../../hooks";
import { emailRegExp, passwordRegExp } from "../../../../utils/utilityEtc";

function Join() {
  const history = useHistory();
  const { JOIN, LOGIN } = URL.ACCOUNT;
  const month = useSelector(state => state.common.monthValue);
  const year = useSelector(state => state.common.yearValue);
  const [formData, handleFormData, handleOneReset] = useInputs({
    learnerName: '',
    learnerGender: '',
    email: '',
    password: '',
    password2: ''
  });
  const [isBtn, onChangeBth] = useInput(true);

  useEffect(() => {
    const { learnerGender, learnerName, email, password, password2 } = formData;

    if (
      month.data && year && learnerGender
      && learnerName && email && password
      && (password === password2)
      && emailRegExp(email)
      && passwordRegExp(password)
    ) {
      onChangeBth(false);
    } else {
      onChangeBth(true);
    }
    
  }, [month, year, formData]);

  const onSubmit = () => {
    if (!isBtn) {
      history.push(JOIN.SUCCESS)
    }
  }


  return (
    <React.Fragment>
      <Header title="회원가입" type="join" />
      <div className="layout-def layout-lc layout-sl bg_gray">
        <div className="container">
          <div className="inner">
            <div className="wirte_form w672">
              <form>
                <IdPwForm
                  formData={formData}
                  handleOneReset={handleOneReset}
                  handleFormData={handleFormData}
                />
                <LearnerInfoForm
                  handleFormData={handleFormData}
                />
              </form>
              <div className="bottom_btn_wrap cls">
                <div className="left">
                  <button
                    type="button"
                    className="btn-small btn-gray btn-left"
                    onClick={() => history.push(LOGIN)}
                  >
                    <span>이전</span>
                  </button>
                </div>
                <div className="right">
                  <button
                    disabled={isBtn}
                    className="btn btn-blue"
                    onClick={onSubmit}
                  >
                    회원가입 완료
                  </button>
                </div>
              </div>
            </div>
            <div className="pc-footer">
              pc에만 나타나는 푸터영역 (내용 미확정)
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Join;
